import { render, staticRenderFns } from "./KLabeledIcon.vue?vue&type=template&id=b27235b2&scoped=true"
import script from "./KLabeledIcon.vue?vue&type=script&lang=js"
export * from "./KLabeledIcon.vue?vue&type=script&lang=js"
import style0 from "./KLabeledIcon.vue?vue&type=style&index=0&id=b27235b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27235b2",
  null
  
)

export default component.exports